export default "__VITE_ASSET__e9c34659__"